
import { defineComponent, PropType, ref, watch, computed } from 'vue';
import { onClickOutside } from '@vueuse/core';

interface FilterSelectOption {
    value: string;
    text: string;
}

export default defineComponent({
    name: 'FilterSelectMulti',
    props: {
        modelValue: {
            type: Array as PropType<Array<string>>,
            default: () => [],
        },
        options: {
            type: Array as PropType<Array<FilterSelectOption>>,
            default: () => [],
        },
        prefix: {
            type: String,
            default: 'filter-select',
        },
        empty: {
            type: String,
            default: 'empty',
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const isOpen = ref(false);
        const value = ref(props.modelValue);
        watch(value, () => {
            emit('update:modelValue', value);
        });
        const currentText = computed(() => {
            const optionIndex = props.options.findIndex((o: FilterSelectOption) => value.value.includes(o.value));
            if (optionIndex >= 0) {
                if (value.value.length > 1) {
                    return `${props.options[optionIndex].text} (+${value.value.length - 1})`;
                }
                return props.options[optionIndex].text;
            }
            return props.empty;
        });

        const clear = () => {
            isOpen.value = false;
            emit('update:modelValue', []);
        };
        const close = (): void => {
            isOpen.value = false;
        };
        const refDropdownList = ref(null);
        onClickOutside(refDropdownList, () => close());
        return {
            value,
            currentText,
            isOpen,
            clear,
            close,
            refDropdownList,
        };
    },
});
